import { Component, OnInit } from '@angular/core';
import { ParkingTicket } from 'src/app/interfaces/installation';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-manager-parking-tickets',
  templateUrl: './manager-parking-tickets.page.html',
  styleUrls: ['./manager-parking-tickets.page.scss'],
})
export class ManagerParkingTicketsPage implements OnInit {
  tickets: ParkingTicket[];
  items: any[] = [];
  flag = false;

  constructor(
    public modalCtrl: ModalController
  ) { }

  ngOnInit() {
    // console.log(this.tickets);
    this.items = this.tickets;
    this.getHourDiff();
  }

  getHourDiff() {
    this.items.forEach(item => {
      const diff = (item.date.final.seconds - item.date.start.seconds) / 3600   
      const decimals = diff.toString().split('.');
      const time = {
        hours: decimals[0],
        minutes: Math.ceil(parseFloat('0.' + decimals[1]) * 60)
      }
      item.time = time.hours + ' hrs, ' + time.minutes + ' min';
      // console.log(time);
      // console.log(item.time);
    });
  }

  activeItem(item) {
    this.flag = true;
    // console.log(item);
  }

  expandItem(item): void {
    if (this.flag) {
      this.flag = false;
      return;
    }
    // console.log(item);
    if (item.expanded) {
      item.expanded = false;
    } else {
      this.items.map(listItem => {
        if (item === listItem) {
          listItem.expanded = !listItem.expanded;
        } else {
          listItem.expanded = false;
        }
        return listItem;
      });
    }
  }

}
